import { render } from "./IntroductionBrand.vue?vue&type=template&id=6e4e5cf3"
import script from "./IntroductionBrand.vue?vue&type=script&lang=js"
export * from "./IntroductionBrand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\iran\\iranrpm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__